import { useState } from 'react'
import { useAppSelector, useAppDispatch } from '../../store/hooks'
import { setProfile } from '../../store/authSlice'
import { supabase } from '../../services/supabaseClient'

interface ConsentScreenProps {
  onComplete: () => void
}

export default function ConsentScreen({ onComplete }: ConsentScreenProps) {
  const dispatch = useAppDispatch()
  const profile = useAppSelector((s) => s.auth.profile)
  const [agreed, setAgreed] = useState(false)
  const [saving, setSaving] = useState(false)

  const handleConsent = async () => {
    if (!agreed || !profile) return
    setSaving(true)

    const { error } = await supabase
      .from('profiles')
      .update({ consented: true })
      .eq('id', profile.id)

    if (!error) {
      dispatch(setProfile({ ...profile, consented: true }))
      onComplete()
    }
    setSaving(false)
  }

  return (
    <div className="onboard-wrap" data-testid="consent-screen">
      <div className="onboard-box">
        <h2>Privacy Notice</h2>
        <div className="consent-text" data-testid="consent-text">
          <p>
            This application stores your responses securely. Your data is only shared
            with members of your assigned team. By continuing, you agree to these terms.
          </p>
        </div>
        <label className="consent-check" data-testid="consent-checkbox-label">
          <input
            type="checkbox"
            checked={agreed}
            onChange={(e) => setAgreed(e.target.checked)}
            data-testid="consent-checkbox"
          />
          I understand and agree
        </label>
        <button
          className="btn btn-primary gate-btn"
          disabled={!agreed || saving}
          onClick={handleConsent}
          data-testid="consent-continue-btn"
        >
          {saving ? 'Saving...' : 'Continue'}
        </button>
      </div>
    </div>
  )
}
